import type { ModalFooterProps as ChakraModalFooterProps } from '@chakra-ui/react';
import { ModalFooter as ChakraModalFooter } from '@chakra-ui/react';
import React from 'react';

import type { OmitChakraProps } from '../../utils/typeUtils';
import { withChakraAs } from '../../utils/withChakraAs';

export type ModalFooterProps = OmitChakraProps<ChakraModalFooterProps>;

export const ModalFooter = withChakraAs<ModalFooterProps, 'footer'>((props) => {
  return <ChakraModalFooter {...props} />;
});
